<p>sales-rebate works!</p>
